import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import { useBTSConfigs } from './BTSStore';
import Edit from './Edit';

const BTSConfigs = () => {
    const {columns, data, getBTSConfigs, setEd, getPackages, getPostTypes} = useBTSConfigs()
    useEffect(() => {
        getBTSConfigs()
        getPackages()
        getPostTypes()
    }, [])
    return (
        <MainTable 
            title="BTS Configs"
            pcolumns={columns}
            pdata={data}
            addBtnDisable={true}
            edit={<Edit />}
            onEdit={(rec) => setEd(rec)}
            setEd={setEd}
            defkey={'id'}
        />
    );
};

export default BTSConfigs;